export default __webpack_public_path__ + "static/media/icon-manageacademy.bc6dc6b8.svg";